import { api } from "../helpers";

export const getShopList = async () => {
  return await api
    .get(`/admin/shop/`)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const syncShopCount = async () => {
  return await api
    .get(`/admin/shop/sync_shop_numbers`)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getShopListSub = async (username: string) => {
  return await api
    .get(`/admin/shop/byshop/${username}`)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getShopLogin = async (data: object) => {
  return await api
    .post(`/auth/adminlogin`, data)
    .then((response) => response.data)
    .catch((error) => error);
};
export const getShopById = async (id: string) => {
  return await api
    .get(`/admin/shop/${id}`)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateEnvVariable = async (data: object) => {
  return await api
    .post(`/admin/shop/env_variable`, data)
    .then((response) => response.data)
    .catch((error) => error);
};

export const createShop = async (data: object) => {
  try {
    const result = await api.post(`/admin/shop`, data);
    return { status: 200, data: result.data };
  } catch (err: any) {
    return { status: err.response.status, message: err.response.message };
  }
};

export const createEnvVariable = async (data: object) => {
  return await api
    .post(`/admin/shop/env_variable`, data)
    .then((response) => response.data)
    .catch((error) => error);
};

export const updateShop = async (id: number, data: object) => {
  return await api
    .put(`/admin/shop/${id}`, data)
    .then((response) => response.data)
    .catch((error) => error);
};

export const updateBilling = async (data: object) => {
  return await api
    .post(`/admin/shop/billing`, data)
    .then((response) => response.data)
    .catch((error) => error);
};

export const updatePermission = async (data: object) => {
  return await api
    .post(`/admin/shop/permission`, data)
    .then((response) => response.data)
    .catch((error) => error);
};

export const activeDeactiveShopById = async (id: string, available: boolean) => {
  return await api
    .delete(`/admin/shop/deActivateShop/${id}/${available}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const deleteOShopById = async (id: string) => {
  return await api
    .delete(`/admin/shop/delete/${id}`)
    .then((response) => response.data)
    .catch((error) => error);
};
export const hardDeleteOShopById = async (username: string) => {
  return await api
    .post(`/admin/shop/harddeleteshop`,
      {
        "email": "kalathiya.mehul.k@gmail.com",
        "password": "mEhul@#123..",
        "name": username
      }
    )
    .then((response) => response.data)
    .catch((error) => error);
};

export const getVersionHistory = async () => {
  return await api
    .get(`/version/history`)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getVersion = async () => {
  return await api
    .get(`/version`)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateVersionHistory = async (data: object) => {
  return await api
    .patch(`/version`, data)
    .then((response) => response.data)
    .catch((error) => error);
};
export const deleteVersionAPI = async (id: any) => {
  return await api
    .delete(`/version/${id}`)
    .then((response) => response.data)
    .catch((error) => error);
};
